module.exports = __webpack_public_path__ + "static/media/America.d9c00200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/America.png
// module id = 538
// module chunks = 0